<div class="toolbar-item m-1 py-1" (click)="toggleActive()">
    <img class="toolbar-item__icon  w-10 h-10" [ngClass]="{'active': isActive}" *ngIf="item?.icon !== undefined && item?.icon !== null" [src]="item.icon" alt="icon"  [pTooltip]="item.msg?.toString() ?? ''"/>
    <div class="toolbar-item__title pt-1">
        <p class="text-center text-white">{{item.title}}</p>
    </div>
</div>

